/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
import { groupBy, max } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { toast } from 'react-toastify';

export const wait = (timeout = 3000) =>
  new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });

// export const isAndroid = () => {
//   const userAgent = navigator.userAgent.toLowerCase();
//   return userAgent.indexOf('android') > -1;
// };

export const isSmallScreen = () => {
  if (window.innerWidth <= 748) {
    return true;
  }
  return false;
};

export const spliceLabelOnMobile = (value) => {
  if (!isSmallScreen()) return value;
  if (typeof value !== 'string') return value;
  // if (value.length > 38) {
  //   return `${value.slice(0, 33)}...`;
  // }
  return value;
};

export const formatCurrency = (() => {
  const formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  return (number) => {
    const parts = formatter.formatToParts(number);
    const strArray = [];
    // filter out the decimal part
    parts.forEach((part) => {
      if (['decimal', 'fraction'].includes(part.type)) return;
      strArray.push(part.value);
    });
    return strArray.join('');
  };
})();

export const formatValue = (value) => Intl.NumberFormat('de-DE').format(value);

export const localizeWizard = (object, options = {}) => {
  const {
    formatter,
    keys = [
      'title',
      'label',
      'subtitle',
      'description',
      'fieldLabel',
      'summaryTitle',
      'submitButtonLabel',
      'text',
      'note',
    ],
  } = options;
  const result = cloneDeep(object);
  function traverse(subtree) {
    if (!subtree) return;
    Object.entries(subtree).forEach(([key, value]) => {
      if (keys.includes(key)) {
        if (subtree.skipI18n) return;
        // eslint-disable-next-line no-param-reassign
        subtree[key] = formatter(value);
      } else if (typeof value === 'object') {
        traverse(value);
      }
    });
  }
  traverse(result);
  return result;
};

export const changeLanguage = () => {
  let countClicks = window?.localStorage?.getItem('countClicksOnFooter');

  if (Number(countClicks) === 5) {
    countClicks = 0;

    const language = window?.localStorage?.getItem('language');
    window?.localStorage?.setItem('language', language === 'en' ? 'de' : 'en');

    document.location.reload();
  }

  if (!countClicks) window?.localStorage?.setItem('countClicksOnFooter', 1);
  else window?.localStorage?.setItem('countClicksOnFooter', Number(countClicks) + 1);
};

// adds "^" symbol to query string where error exist
export const formatQueryByErrorPositions = ({ queryString, errorPositions }) => {
  if (!errorPositions) return queryString;
  try {
    const columnsByLine = groupBy(errorPositions, 'line');
    const lineNumbers = Object.keys(columnsByLine).sort((a, b) => b - a);
    const queryStringLines = queryString.split('\n');
    lineNumbers.forEach((lineIndex) => {
      const columns = columnsByLine[lineIndex].map((object) => object.column);
      const maxColumn = max(columns);
      queryStringLines.splice(lineIndex, 0, '');
      queryStringLines[lineIndex] = new Array(maxColumn).fill(' ');
      columns.forEach((column) => {
        queryStringLines[lineIndex][column - 1] = '^';
      });
      queryStringLines[lineIndex] = queryStringLines[lineIndex].join('');
    });
    return queryStringLines.join('\n').trim();
  } catch (e) {
    console.error(e);
    return queryString;
  }
};

export const formatGraphqlErrors = (error) => {
  const graphqlErrorMsg = Array.isArray(error.graphQLErrors)
    ? error.graphQLErrors.map((err) => err.message).join('\n')
    : null;

  const { networkError } = error;
  const networkErrorResultMsg = Array.isArray(networkError?.result?.errors)
    ? networkError?.result?.errors.map((err) => err.message).join('\n')
    : null;
  // const networkErrorMsg = networkError ? i18n.t('errors.serverConnectionError') : null;
  const networkErrorMsg = networkError
    ? 'Verbindung zum Server derzeit nicht möglich, bitte Internetverbindung prüfen!'
    : null;

  const msg = graphqlErrorMsg || networkErrorResultMsg || networkErrorMsg;
  const e = msg ? new Error(msg) : error;

  return e;
};

export const toastErrorMessage = (error) => {
  const e = formatGraphqlErrors(error);
  toast.error(e.message);
};

export const grabErrorMessage = (error) => formatGraphqlErrors(error).message;
